import { useCallback, useEffect, useState } from "react";
import useGraphQLClient from "./useGraphQLClient";
import { READ_OPERATIONAL_CLARITY_DASHBOARD_BY_TENANT_ID } from "../graph/dashboard/queries";

const useOperationalClarityDashboard = ({ tenantId }) => {
  const client = useGraphQLClient();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(tenantId));
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    if (!tenantId) {
      setData(null);
      setLoading(false);
      setError(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await client.request(
        READ_OPERATIONAL_CLARITY_DASHBOARD_BY_TENANT_ID,
        { tenantId }
      );

      setData(response.readLatestOperationalClarityDashboard);
    } catch (err) {
      console.error("Failed to load operational clarity dashboard:", err);
      setError(err);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [client, tenantId]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    data,
    loading,
    error,
    refetch: fetchDashboard,
  };
};

export default useOperationalClarityDashboard;